(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plenty-help"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var BOUND = '__phBound';
    var reduce = function () {
      return window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
    };
    var norm = function (t) {
      return (t || '')
        .toLowerCase()
        .normalize('NFD')
        .replace(/[̀-ͯ]/g, '')
        .replace(/[^a-z0-9 ]+/g, ' ')
        .replace(/\s+/g, ' ')
        .trim();
    };
    var headerOffset = function () {
      var v = parseInt(getComputedStyle(document.body).getPropertyValue('--header-height'), 10);
      return (isNaN(v) ? 0 : v) + 8;
    };

    function init(root) {
      if (root.__ph) return;
      root.__ph = true;
      root.setAttribute('data-ph-js', '');

      var pages = {};
      root.querySelectorAll('[data-ph-page]').forEach(function (p) {
        pages[p.getAttribute('data-ph-page')] = p;
      });
      var side = root.querySelector('[data-ph-side]');
      var navLinks = root.querySelectorAll('[data-ph-nav]');
      var baseTitle = document.title;
      var current = '';
      var first = true;

      // índice de busca montado a partir do próprio DOM (uma fonte só)
      var index = [];
      root.querySelectorAll('[data-ph-q]').forEach(function (el) {
        var btn = el.querySelector('.ph-qb');
        var ans = el.querySelector('.ph-qa p');
        var page = el.closest('[data-ph-page]');
        var q = btn.firstChild ? btn.firstChild.textContent.trim() : '';
        var a = ans ? ans.textContent.trim() : '';
        var tt = page.getAttribute('data-ph-title') || '';
        index.push({
          topic: el.getAttribute('data-ph-topic'),
          i: el.getAttribute('data-ph-i'),
          q: q,
          a: a,
          t: tt,
          h: norm(q + ' ' + a + ' ' + tt)
        });
      });

      function setOpen(item, on) {
        item.classList.toggle('is-open', on);
        item.querySelector('.ph-qb').setAttribute('aria-expanded', on ? 'true' : 'false');
      }

      function scrollToRoot() {
        var top = root.getBoundingClientRect().top;
        var off = headerOffset();
        if (top < off) {
          window.scrollTo({ top: top + window.pageYOffset - off, behavior: 'instant' });
        }
      }

      function route() {
        var raw = (location.hash || '').replace(/^#/, '');
        var parts = raw.split('/');
        var id = parts[0];
        var qi = parts[1];
        // hash que não é da central (ex.: pular para o conteúdo): não mexe
        if (raw && !pages[id]) return;
        var page = pages[id];
        var changed = id !== current || first;
        var wasFirst = first;

        if (changed) {
          Object.keys(pages).forEach(function (k) {
            pages[k].classList.remove('is-on', 'pc-in');
          });
          void page.offsetWidth;
          page.classList.add('is-on');
          if (!wasFirst) page.classList.add('pc-in');
          root.setAttribute('data-ph-view', id ? 'page' : 'home');
          current = id;
          navLinks.forEach(function (a) {
            if (a.getAttribute('data-ph-nav') === id) a.setAttribute('aria-current', 'page');
            else a.removeAttribute('aria-current');
          });
          if (side && id) {
            var cur = side.querySelector('[aria-current]');
            if (cur && side.scrollWidth > side.clientWidth) {
              side.scrollLeft = cur.offsetLeft - (side.clientWidth - cur.offsetWidth) / 2;
            }
          }
          var ttl = page.getAttribute('data-ph-title');
          document.title = ttl ? ttl + ' | ' + baseTitle : baseTitle;
        }

        var target = null;
        if (id && qi != null && qi !== '') {
          target = root.querySelector('[data-ph-topic="' + id + '"][data-ph-i="' + qi + '"]');
          if (target) setOpen(target, true);
        }

        if (target) {
          var y = target.getBoundingClientRect().top + window.pageYOffset - headerOffset() - 12;
          window.scrollTo({ top: Math.max(0, y), behavior: reduce() || wasFirst ? 'instant' : 'smooth' });
        } else if (changed && (!wasFirst || raw)) {
          scrollToRoot();
        }

        if (changed && !wasFirst) {
          var h1 = page.querySelector('.ph-h1');
          if (h1) h1.focus({ preventScroll: true });
        }
        first = false;
      }

      root.__phRoute = route;

      // links internos da central: navegam sem pular a página
      root.addEventListener('click', function (e) {
        if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        var a = e.target.closest('a[href^="#"]');
        if (a && root.contains(a)) {
          var href = a.getAttribute('href');
          e.preventDefault();
          var url = href === '#' ? location.pathname + location.search : href;
          if (href === '#' ? location.hash : href !== location.hash) history.pushState(null, '', url);
          route();
          return;
        }
        var b = e.target.closest('.ph-qb');
        if (b && root.contains(b)) {
          var it = b.closest('.ph-qi');
          setOpen(it, !it.classList.contains('is-open'));
        }
      });

      // busca: responde enquanto digita
      var input = root.querySelector('[data-ph-search]');
      var box = root.querySelector('[data-ph-results]');
      var form = root.querySelector('[data-ph-search-form]');
      if (form) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (input) input.blur();
        });
      }
      if (input && box) {
        input.addEventListener('input', function () {
          var q = norm(input.value);
          box.textContent = '';
          if (q.length < 2) {
            box.classList.remove('is-on');
            return;
          }
          var terms = q.split(' ');
          var hits = index
            .filter(function (x) {
              return terms.every(function (t) {
                return x.h.indexOf(t.length > 3 ? t.replace(/s$/, '') : t) >= 0;
              });
            })
            .slice(0, 6);
          box.classList.add('is-on');
          if (!hits.length) {
            var p = document.createElement('p');
            p.appendChild(document.createTextNode('Nada encontrado. Tente outra palavra ou '));
            var l = document.createElement('a');
            l.href = '#contato';
            l.textContent = 'fale com a gente';
            p.appendChild(l);
            p.appendChild(document.createTextNode('.'));
            box.appendChild(p);
            return;
          }
          hits.forEach(function (x) {
            var a = document.createElement('a');
            a.href = '#' + x.topic + '/' + x.i;
            var b = document.createElement('b');
            b.textContent = x.q;
            var s = document.createElement('span');
            s.textContent = x.a;
            var em = document.createElement('em');
            em.textContent = x.t;
            a.appendChild(b);
            a.appendChild(s);
            a.appendChild(em);
            box.appendChild(a);
          });
        });
      }

      // rastrear: o dado digitado vai no texto do WhatsApp
      var track = root.querySelector('[data-ph-track]');
      var wa = root.querySelector('[data-ph-track-wa]');
      if (track && wa) {
        var base = wa.getAttribute('data-ph-wa-base');
        var sep = wa.getAttribute('data-ph-wa-sep') || '?';
        var msg = wa.getAttribute('data-ph-wa-msg') || '';
        var upd = function () {
          var v = track.value.trim();
          var text = (msg + (v ? ' ' + v : '')).trim();
          wa.href = text ? base + sep + 'text=' + encodeURIComponent(text) : base;
        };
        track.addEventListener('input', upd);
        upd();
      }

      route();
    }

    function initAll() {
      document.querySelectorAll('[data-ph]').forEach(init);
    }

    if (!window[BOUND]) {
      window[BOUND] = true;
      var all = function () {
        document.querySelectorAll('[data-ph]').forEach(function (r) {
          if (r.__phRoute) r.__phRoute();
        });
      };
      window.addEventListener('hashchange', all);
      window.addEventListener('popstate', all);
      document.addEventListener('shopify:section:load', initAll);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plenty-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(el) {
      if (el.__phero) return;
      el.__phero = true;
      var slides = el.querySelectorAll('[data-phero-s]');
      var dots = el.querySelectorAll('[data-phero-dot]');
      if (slides.length < 2) return;
      var i = 0;
      var secs = parseFloat(el.dataset.seconds) || 6;
      var auto = el.dataset.autoplay === 'true' && !matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;
      var left = secs * 1000;
      var started = 0;
      el.style.setProperty('--phero-secs', secs + 's');

      function go(n, user) {
        i = (n + slides.length) % slides.length;
        slides.forEach(function (s, k) {
          var on = k === i;
          s.classList.toggle('is-on', on);
          if (on) s.removeAttribute('aria-hidden');
          else s.setAttribute('aria-hidden', 'true');
        });
        dots.forEach(function (d, k) {
          var on = k === i;
          d.classList.toggle('is-on', on);
          d.setAttribute('aria-selected', on ? 'true' : 'false');
          var bar = d.querySelector('i');
          if (bar && on) {
            bar.style.animation = 'none';
            void bar.offsetWidth;
            bar.style.animation = '';
          }
        });
        document.documentElement.toggleAttribute('data-phero-first', i === 0);
        left = secs * 1000;
        if (auto) schedule();
      }
      function schedule() {
        clearTimeout(timer);
        started = Date.now();
        el.setAttribute('data-playing', '');
        timer = setTimeout(function () { go(i + 1); }, left);
      }
      function pause() {
        if (!auto || el.hasAttribute('data-paused')) return;
        clearTimeout(timer);
        left = Math.max(400, left - (Date.now() - started));
        el.setAttribute('data-paused', '');
      }
      function resume() {
        if (!auto || !el.hasAttribute('data-paused')) return;
        el.removeAttribute('data-paused');
        schedule();
      }
      dots.forEach(function (d, k) {
        d.addEventListener('click', function () {
          el.removeAttribute('data-paused');
          go(k, true);
        });
      });
      el.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') pause(); });
      el.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') resume(); });
      el.addEventListener('focusin', pause);
      el.addEventListener('focusout', resume);
      document.addEventListener('visibilitychange', function () { document.hidden ? pause() : resume(); });

      var x0 = null;
      el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      el.addEventListener('touchend', function (e) {
        if (x0 == null) return;
        var dx = e.changedTouches[0].clientX - x0;
        x0 = null;
        if (Math.abs(dx) > 40) {
          el.removeAttribute('data-paused');
          go(i + (dx < 0 ? 1 : -1), true);
        }
      });

      document.documentElement.setAttribute('data-phero-first', '');
      if (auto) schedule();
    }
    function boot() { document.querySelectorAll('[data-phero]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();
})();
